import { useCMSPage } from "../../../context/CMSContext";

export default function CalcHero() {
  const { data: calcCMS } = useCMSPage("calculator");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const heroCMS: any = (calcCMS as any)?.hero ?? {};

  const badge      = heroCMS?.badge       ?? "Free Estimator";
  const headline   = heroCMS?.headline    ?? "Waste Calculator.";
  const subheadline= heroCMS?.subheadline ?? "How much have you got? Pick your items, get a price and load size in 30 seconds. No phone call needed unless you want one.";

  return (
    <section className="bg-cl-dark pt-32 pb-16">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10 text-center">
        <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
          <i className="ri-calculator-line text-cl-dark text-xs"></i>
          <span className="text-cl-dark text-xs font-black uppercase tracking-widest">{badge}</span>
        </div>
        <h1 className="text-4xl md:text-6xl font-black text-white leading-tight mb-4">{headline}</h1>
        <p className="text-white/60 text-base md:text-lg font-semibold max-w-xl mx-auto">{subheadline}</p>
      </div>
    </section>
  );
}
